import { gql } from '@apollo/client';
import { getSelectedVehicleQuery } from 'next-common';

export const getSelectedVehicleQueryParsed = gql`
  ${getSelectedVehicleQuery}
`;
